import React, { useEffect, useState } from "react";
import Axios from 'axios';
import Navbar from "../../../components/Navbar";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import { useNavigate } from "react-router-dom";
import SubmitButton from "../../../components/Button";
import style from "./Navios.module.css";
import { SnackbarProvider, useSnackbar } from 'notistack';

const Navios = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [naviosList, setNaviosList] = useState([]);
  const [tipo, setTipo] = useState(""); // FERTILIZANTE ou CONTAINER
  const [navioSelecionado, setNavioSelecionado] = useState(null);

  useEffect(() => {
    getNavios();
  }, []);

  const getNavios = () => {
    Axios.get('https://portal.jc7transportes.com.br/api/navio')
      .then((response) => {
        setNaviosList(response.data);
      });
  };

  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  };

  const validaOp = () => {
    if (!navioSelecionado) {
      return showAlert("Selecione um navio para continuar.", "warning");
    }

    if (navioSelecionado.STATUS === 'OPERANDO') {
      return showAlert('Navio já está em operação!', 'error');
    } else {
      return navigate(`/operacao/cadastro/${navioSelecionado.NOME_NAVIO}/${navioSelecionado.COD_NAVIO}`);
    }
  };

  const naviosFiltrados = naviosList.filter((navio) => {
    const nome = navio.NOME_NAVIO?.toUpperCase() || "";
    const contemLote = nome.includes("LOTE");

    if (tipo === "FERTILIZANTE") {
      return;
    } else if (tipo === "CONTAINER") {
      return contemLote;
    }
    return false;
  });

  return (
    <>
      <Navbar navs />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div className={style.active}>Navios</div>
            <div className={style.navbar} onClick={() => navigate("/navios/cadastro")}>
              Cadastrar Navio
            </div>
          </div>

          <div className={style.filtros}>
            <div style={{ marginBottom: '1rem', fontWeight: 'bold' }}>Selecione o tipo de carga:</div>
            <div style={{ marginBottom: '1.5rem' }}>
              <label style={{ marginRight: '2rem' }}>
                <input
                  type="radio"
                  value="FERTILIZANTE"
                  checked={tipo === "FERTILIZANTE"}
                  onChange={(e) => {
                    setTipo(e.target.value);
                    setNavioSelecionado(null);
                  }}
                />{" "}
                Fertilizante
              </label>
              <label>
                <input
                  type="radio"
                  value="CONTAINER"
                  checked={tipo === "CONTAINER"}
                  onChange={(e) => {
                    setTipo(e.target.value);
                    setNavioSelecionado(null);
                  }}
                />{" "}
                Contêiner
              </label>
            </div>

            {/* SELECT NATIVO */}
            {tipo && (
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: "block", marginBottom: 5 }}>Selecione o Navio</label>
                <select
                  value={navioSelecionado?.COD_NAVIO?.toString() || ""}
                  onChange={(e) => {
                    const codSelecionado = parseInt(e.target.value);
                    const navio = naviosList.find(n => n.COD_NAVIO === codSelecionado);
                    setNavioSelecionado(navio);
                  }}
                  style={{ padding: "0.5rem", width: "100%" }}
                >
                  <option value="">-- Selecione --</option>
                  {naviosFiltrados.map((navio) => (
                    <option key={navio.COD_NAVIO} value={navio.COD_NAVIO}>
                      {navio.NOME_NAVIO} - {navio.IMO_NAVIO}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {navioSelecionado && (
              <div style={{ marginTop: "1.5rem" }}>
                <SubmitButton text="Cadastrar Operação" onClick={validaOp} />
              </div>
            )}
          </div>
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}>
      <Navios />
    </SnackbarProvider>
  );
}
